export default function balanceText(text, lineLength) {
  var j, len, letterCount, line, lineCount, lines, ref, word
  lineCount = Math.ceil(text.length / lineLength)
  letterCount = text.length / lineCount
  lines = []
  line = ''
  ref = text.split(/\s+/)
  for (j = 0, len = ref.length; j < len; j++) {
    word = ref[j]
    line += word + ' '
    if (line.length > letterCount && lines.length < lineCount) {
      lines.push(line)
      line = ''
    }
  }
  lines.push(line)
  return lines.join('<br />')
}
